export default __webpack_public_path__ + "static/media/pwd_type_3_1.83a43afa.png";